module.exports = __webpack_public_path__ + "images/backgrounds/city/full.1bbbf09d491d444d207e.jpg";